import React from 'react';

import { defaultTheme } from './../../styles/theme/default';
import { IIcon } from './../../@types/icons';

export function Voice ({ strokeColor }: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      fill="none"
      viewBox="0 0 17 16"
    >
      <path
        stroke={
          strokeColor
            ? defaultTheme.colors[strokeColor]
            : defaultTheme.colors.dimGray
        }
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 6H2.08c-.34 0-.665.105-.905.293C.935 6.48.8 6.735.8 7v2c0 .265.135.52.375.707.24.188.565.293.905.293H4V6zM4 9.925l4.55 3.504a1.378 1.378 0 001.164.077c.2-.075.37-.194.492-.346a.851.851 0 00.194-.51v-9.3a.835.835 0 00-.15-.494 1.083 1.083 0 00-.432-.362 1.378 1.378 0 00-1.164.077L4 6.075M14.008 4.4c1.107.931 1.592 2 1.592 3.323 0 1.877-.574 2.707-1.592 3.877M12.8 6.4c.553.448.837 1.019.796 1.6.041.581-.243 1.152-.796 1.6"

      />
    </svg>
  );
}
